/* tslint:disable */
import type * as ApiTypes from '@ogm3/server-types';
import * as Fetch from '../../fetch';
import type * as Actions from '../../async-actions';

// RestrictionsController

/**
 * Gets the categories under a certain category.
 */
export function GetSubCategories(
	categoryId: number
): Promise<Actions.ApiResult<ApiTypes.GetSubCategoriesResult>> {
	const uri = `/api/v3/restrictions/subCategories?categoryId=${categoryId}`;
	const config: Fetch.RequestConfig = {
		uri,
		method: 'GET',
	};
	return Fetch.fetch2<ApiTypes.GetSubCategoriesResult>(config);
}

/**
 * Update the Restriction List Location Links.
 */
export function UpdateRestrictionListLocationLinks(
	args: ApiTypes.UpdateRestrictionListLocationLinksArgs
): Promise<
	Actions.ApiResult<ApiTypes.UpdateRestrictionListLocationLinksResult>
> {
	const uri = `/api/v3/restrictions/updateRestrictionListLocationLinks`;
	const config: Fetch.RequestConfig = {
		uri,
		method: 'POST',
		body: JSON.stringify(args),
	};
	return Fetch.fetch2<ApiTypes.UpdateRestrictionListLocationLinksResult>(
		config
	);
}

/**
 * Checks if a product number is valid for a restriction list.
 */
export function CheckProductNumbers(
	args: ApiTypes.CheckProductNumbersArgs
): Promise<Actions.ApiResult<ApiTypes.CheckProductNumbersResult>> {
	const uri = `/api/v3/restrictions/check-products`;
	const config: Fetch.RequestConfig = {
		uri,
		method: 'POST',
		body: JSON.stringify(args),
	};
	return Fetch.fetch2<ApiTypes.CheckProductNumbersResult>(config);
}

/**
 * Add item restrictions to a restriction list.
 */
export function AddItemRestrictions(
	args: ApiTypes.AddItemRestrictionsArgs
): Promise<Actions.ApiResult<ApiTypes.AddItemRestrictionsResult>> {
	const uri = `/api/v3/restrictions/add-item-restrictions`;
	const config: Fetch.RequestConfig = {
		uri,
		method: 'POST',
		body: JSON.stringify(args),
	};
	return Fetch.fetch2<ApiTypes.AddItemRestrictionsResult>(config);
}
